export default __webpack_public_path__ + "a87bd4aed7bc7616ec825e5e2b7d9b30.svg";